import { createSelector } from "reselect";
import get from "lodash/get";

const selectForm = state => get(state, "form");

// ***************************************************************
// ************** form selectors ******************
// ***************************************************************

export const formValuesSelector = form =>
  createSelector(selectForm, formStore => get(formStore, `${form}.values`, {}));

// ***************************************************************
// ************** form makeSelect *****************
// ***************************************************************

export const makeSelectFormValues = form => formValuesSelector(form);

export const makeSelectHasDeliveryAddressError = form =>
  createSelector(selectForm, formStore => {
    return get(formStore, `${form}.values.delivery_location_error`);
  });

export const makeSelectHasAddressError = (form, type) =>
  createSelector(selectForm, formStore => {
    return get(formStore, `${form}.values.${type}_location_error`);
  });

export const makeSelectActiveFiled = form =>
  createSelector(selectForm, formStore => {
    return get(formStore, `${form}.active`);
  });

export const makeSelectFormList = () =>
  createSelector(selectForm, forms => {
    return forms;
  });
